import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight, Phone, Menu, X, ChevronLeft, ChevronRight } from 'lucide-react';
import './Projects.css';
import './Home.css'; 

// --- Shared Header Data ---
const navItems = [
    { id: 'home', label: 'Home', path: '/' }, 
    { id: 'about', label: 'About', path: '/about' },
    { id: 'services', label: 'Services', path: '/services' },
    { id: 'projects', label: 'Projects', path: '/projects' },
    { id: 'contact', label: 'Contact', path: '/contact' }
];

// Helper Component for Header content
const HeaderContent = ({ isMobileMenuOpen, setIsMobileMenuOpen }) => {
    const location = useLocation();
    const getLinkClass = (path) => location.pathname === path ? 'active' : '';

    return (
        <header className="header">
            <div className="header-content">
                <img src="/assets/Construction Logo (4).png" alt="S&L Construction Logo" className="header-logo" />
                <Link to="/" className="logo">
                    S&L Construction, Inc.
                </Link>
                <nav className="nav-desktop">
                    {navItems.map(item => (
                        <Link 
                            key={item.id}
                            to={item.path} 
                            className={`nav-link ${getLinkClass(item.path)}`}
                        >
                            {item.label}
                        </Link>
                    ))}
                </nav>
                <a href="tel:+13126077476" className="header-phone">
                    <Phone size={18} />
                    (312) 607-7476
                </a>
                <button
                    className="mobile-menu-button"
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                >
                    {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>
            <div className={`nav-mobile ${isMobileMenuOpen ? 'open' : ''}`}>
                {navItems.map(item => (
                    <Link 
                        key={item.id}
                        to={item.path}
                        className={`nav-link-mobile ${getLinkClass(item.path)}`}
                        onClick={() => setIsMobileMenuOpen(false)} 
                    >
                        {item.label}
                    </Link>
                ))}
                <a href="tel:+13126077476" className="nav-phone-mobile">
                    <Phone size={18} />
                    (312) 607-7476
                </a>
            </div>
        </header>
    );
};

// Helper Component for Footer Content
const FooterContent = () => (
    <footer className="footer-section">
        <div className="footer-content">
            <p className="footer-copy">© 2025 S&L Construction, Inc. | All Rights Reserved</p>
            <a href="tel:+13126077476" className="footer-phone">
                <Phone size={16} />
                Call Us: (312) 607-7476
            </a>
        </div>
    </footer>
);


// ----------------------------------------------------
// Project Modal Component (Uses Inline CSS) - GRID VIEW
// ----------------------------------------------------

// const modalStyles = {
//     overlay: {
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         backgroundColor: 'rgba(0, 0, 0, 0.95)', 
//         zIndex: 1000,
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         transition: 'opacity 0.3s ease-in-out',
//     },
//     content: {
//         width: '95%',
//         maxWidth: '1400px',
//         height: '95%',
//         maxHeight: '900px',
//         position: 'relative',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         backgroundColor: 'rgba(20, 20, 30, 1)', 
//         borderRadius: '8px',
//         padding: '20px',
//     },
//     closeButton: {
//         position: 'absolute',
//         top: '20px',
//         right: '20px',
//         background: 'rgba(255, 255, 255, 0.2)',
//         border: 'none',
//         borderRadius: '50%',
//         cursor: 'pointer',
//         color: 'white',
//         padding: '10px',
//         zIndex: 10,
//     },
//     modalHeader: {
//         width: '100%',
//         textAlign: 'center',
//         padding: '0 40px 20px 40px',
//     },
//     modalTitle: {
//         color: 'white',
//         fontSize: '2.5rem',
//         fontWeight: '700',
//         margin: '0',
//     },
//     modalSubtitle: {
//         color: '#aaa',
//         fontSize: '1rem',
//         margin: '5px 0 0 0',
//     },
//     gridContainer: {
//         width: '100%',
//         height: '100%',
//         overflowY: 'auto', 
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
//         gap: '20px',
//         padding: '0 10px', 
//     },
//     gridImageWrapper: {
//         width: '100%',
//         paddingBottom: '75%', // 4:3 Aspect ratio
//         position: 'relative',
//         overflow: 'hidden',
//         borderRadius: '6px',
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
//         transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//         cursor: 'zoom-in', // Suggests click action
//     },
//     gridImageWrapperHover: {
//         transform: 'scale(1.03)',
//         boxShadow: '0 8px 20px rgba(0, 0, 0, 0.7)',
//     },
//     gridImage: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     }
// };


const modalStyles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0,0,0,0.9)',
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)'
  },
  content: {
    width: 'min(1280px, 96vw)',
    maxHeight: '96vh',
    borderRadius: 14,
    backgroundColor: 'rgba(20,20,24,0.97)',
    boxShadow: '0 30px 80px rgba(0,0,0,0.7)',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'hidden',
  },
  thumbsRow: {
  display: 'flex',
  gap: 10,
  overflowX: 'auto',
  maxWidth: 'min(640px, 92vw)',
  margin: '0 auto',
  paddingBottom: 4,
  /* Hide scrollbar for WebKit browsers */
  scrollbarWidth: 'none',       // hides scrollbar in Firefox
  msOverflowStyle: 'none',      // hides scrollbar in IE 10+
  /* The below hides scrollbar in Chrome, Safari, Opera */
  '::-webkit-scrollbar': {
    display: 'none',
  },
},
  header: {
    height: 70,
    padding: '18px 48px 10px 22px',
    backgroundColor: 'rgba(30,30,38,0.98)',
    borderBottom: '1px solid rgba(255,255,255,0.12)',
    color: 'white',
    userSelect: 'none',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'relative',
    zIndex: 10,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
  },
  title: {
    fontSize: '1.9rem',
    fontWeight: 700,
    margin: 0,
  },
  meta: {
    fontSize: '1rem',
    opacity: 0.85,
    marginTop: 4,
  },
  counter: {
    fontSize: '1rem',
    opacity: 0.85,
    fontWeight: 600,
  },
  closeButton: {
    position: 'absolute',
    top: 14,
    right: 14,
    background: 'rgba(255,255,255,0.15)',
    borderRadius: '50%',
    border: 'none',
    cursor: 'pointer',
    width: 38,
    height: 38,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 11,
    color: '#fff',
  },
  body: {
    flex: 1,
    position: 'relative',
    backgroundColor: 'rgba(10,10,15,1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 20,
  },
  image: {
    maxWidth: '90vw',
    maxHeight: '62vh',
    objectFit: 'contain',
    borderRadius: 12,
    userSelect: 'none',
  },
  navBtn: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'rgba(255, 255, 255, 0.18)',
    borderRadius: 16,
    border: 'none',
    width: 64,
    height: 64,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    zIndex: 12,
    transition: 'background-color 0.2s ease',
  },
  navLeft: {
    left: 8,
    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.4)' },
  },
  navRight: {
    right: 8,
    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.4)' },
  },
  thumbWrapper: {
    borderTop: '1px solid rgba(255,255,255,0.12)',
    backgroundColor: 'rgba(20,20,24,0.97)',
    padding: '14px 12px',
  },
  thumbRow: {
    display: 'flex',
    gap: 12,
    overflowX: 'auto',
    scrollbarWidth: 'thin',
    maxWidth: '620px',
    margin: '0 auto',
  },
  thumb: {
    width: 110,
    height: 70,
    borderRadius: 12,
    objectFit: 'cover',
    cursor: 'pointer',
    opacity: 0.6,
    border: '2px solid transparent',
    flexShrink: 0,
    transition: 'opacity 0.2s, transform 0.2s, border-color 0.2s',
  },
  thumbActive: {
    opacity: 1,
    borderColor: 'rgba(255,255,255,0.85)',
    transform: 'scale(1.05)',
  }
};

const ProjectModal = ({ project, onClose }) => {
  const [index, setIndex] = useState(0);
  const thumbsRef = useRef(null);

  useEffect(() => {
    if (!project) return;
    setIndex(0);
  }, [project]);

  useEffect(() => {
    if (!project) return;
    const total = project.gallery?.length ?? 0;
    if (!total) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') setIndex(i => (i - 1 + total) % total);
      if (e.key === 'ArrowRight') setIndex(i => (i + 1) % total);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [project, onClose]);

  useEffect(() => {
    if (!thumbsRef.current) return;
    const active = thumbsRef.current.querySelector(`[data-thumb='${index}']`);
    if (active) {
      active.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }, [index]);

  if (!project || !project.gallery || project.gallery.length === 0) return null;

  const total = project.gallery.length;
  const prev = () => setIndex(i => (i - 1 + total) % total);
  const next = () => setIndex(i => (i + 1) % total);
  const currentSrc = project.gallery[index];

  const headerMeta = [project.category, project.location].filter(Boolean).join(' • ');

  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.content} onClick={e => e.stopPropagation()}>
        <button onClick={onClose} style={modalStyles.closeButton} aria-label="Close modal">
          <X size={22} />
        </button>

        <div style={modalStyles.header}>
          <div style={modalStyles.titleRow}>
            <h2 style={modalStyles.title}>{project.title}</h2>
            <div style={modalStyles.counter}>{index + 1} / {total}</div>
          </div>
          <p style={modalStyles.meta}>{headerMeta || 'Project Gallery'}</p>
        </div>

        <div style={modalStyles.body}>
          <button
            type="button"
            style={{ ...modalStyles.navBtn, ...modalStyles.navLeft }}
            onClick={prev}
            aria-label="Previous image"
          >
            <ChevronLeft size={34} />
          </button>

          <img src={currentSrc} alt={`${project.title} - ${index + 1}`} style={modalStyles.image} />

          <button
            type="button"
            style={{ ...modalStyles.navBtn, ...modalStyles.navRight }}
            onClick={next}
            aria-label="Next image"
          >
            <ChevronRight size={34} />
          </button>
        </div>

        <div style={modalStyles.thumbWrapper}>
          <div className="thumbs-row" style={modalStyles.thumbsRow} ref={thumbsRef}>
            {project.gallery.map((src, i) => (
              <img
                key={`${src}-${i}`}
                data-thumb={i}
                src={src}
                alt={`${project.title} thumbnail ${i + 1}`}
                style={i === index ? { ...modalStyles.thumb, ...modalStyles.thumbActive } : modalStyles.thumb}
                onClick={() => setIndex(i)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};


// ----------------------------------------------------
// Project Data with Gallery Arrays - CORRECTED PATHS
// ----------------------------------------------------

const projectGalleries = {
    // Corrected /assests/ to /assets/
    kitchens: [
        '/assets/kitchens 1.png', '/assets/kitchens 2.png', '/assets/kitchens 3.png', 
        '/assets/kitchens 4.png', '/assets/kitchens 5.png', '/assets/kitchens 6.png', 
        '/assets/kitchens 7.png', '/assets/kitchens 8.jpg', '/assets/kitchens 9.jpg', 
        '/assets/kitchens 10.jpg', '/assets/kitchens 11.jpg'
    ],
    // Corrected /assests/ to /assets/
    hydePark: [
        '/assets/hyde park mansion restoration 1.jpg', '/assets/hyde park mansion restoration 2.jpg', 
        '/assets/hyde park mansion restoration 3.jpg', '/assets/hyde park mansion restoration 4.jpg', 
        '/assets/hyde park mansion restoration 5.jpg', '/assets/hyde park mansion restoration 6.jpg', 
        '/assets/hyde park mansion restoration 7.jpg', '/assets/hyde park mansion restoration 8.jpg', 
        '/assets/hyde park mansion restoration 9.jpg', '/assets/hyde park mansion restoration 10.jpg', 
        '/assets/hyde park mansion restoration 11.jpg'
    ],
    // Corrected /assests/ to /assets/
    bathrooms: [
        '/assets/bathrooms 1.jpg', '/assets/bathrooms 2.jpg', '/assets/bathrooms 3.jpg', 
        '/assets/bathrooms 4.jpg', '/assets/bathrooms 5.png', '/assets/bathrooms 6.png', 
        '/assets/bathrooms 7.png', '/assets/bathrooms 8.png', '/assets/bathrooms 9.jpg', 
        '/assets/bathrooms 10.jpg', '/assets/bathrooms 11.jpg', '/assets/bathrooms 12.jpg',
        '/assets/bathrooms 13.png', '/assets/bathrooms 14.png'
    ],
    // Corrected /assests/ to /assets/
    newHouse: [
        '/assets/new house 1.jpg', '/assets/new house 2.jpg', '/assets/new house 3.jpg', 
        '/assets/new house 4.jpg', '/assets/new house 5.jpg', '/assets/new house 6.jpg', 
        '/assets/new house 7.jpg', '/assets/new house 8.jpg', '/assets/new house 9.jpg', 
        '/assets/new house 10.jpg', '/assets/new house 11.jpg'
    ],
    // Corrected /assests/ to /assets/
    condoProject: [
        '/assets/condo project 1.jpg', '/assets/condo project 2.jpg', '/assets/condo project 3.jpg', 
        '/assets/condo project 4.jpg', '/assets/condo project 5.jpg', '/assets/condo project 6.jpg'
    ],
    // Corrected /assests/ to /assets/
    jamesMontgomery: [
        '/assets/james motgomery mansion restoration 1.jpg', '/assets/james motgomery mansion restoration2.jpg',
    ],
    // Corrected /assests/ to /assets/
    mansions: [
        '/assets/mansions 1.jpg', '/assets/mansions 2.jpg'
    ]
};

// ----------------------------------------------------
// Projects Component
// ----------------------------------------------------

const Projects = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [activeProject, setActiveProject] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [modalProject, setModalProject] = useState(null); 
    const sectionRef = useRef(null);

    // Main useEffect for Intersection Observer
    useEffect(() => {
        window.scrollTo(0, 0); 
        const currentRef = sectionRef.current;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    const openModal = (project) => {
        setModalProject(project);
    };

    const closeModal = () => {
        setModalProject(null);
    };

    const projects = [
        {
            id: 1,
            title: 'Custom Kitchen Remodel',
            description: 'A comprehensive gallery of our finest custom kitchen transformations with modern designs and luxury finishes.',
            category: 'Remodeling',
            imageUrl: projectGalleries.kitchens[0], 
            gallery: projectGalleries.kitchens ,
        },
        {
            id: 2,
            title: 'Hyde Park Mansion Restoration',
            description: 'Preserving the grandeur and history of a Hyde Park mansion with meticulous restoration work.',
            category: 'Restoration',
            imageUrl: projectGalleries.hydePark[0],
            gallery: projectGalleries.hydePark ,
        },
        {
            id: 3,
            title: 'Luxury Bathroom Suite Designs',
            description: 'A collection of spa-like bathroom remodels featuring premium materials, custom tile, and heated floors.',
            category: 'Interior/Exterior',
            imageUrl: projectGalleries.bathrooms[0],
            gallery: projectGalleries.bathrooms,
        },
        {
            id: 4,
            title: 'New Custom Home Builds',
            description: 'Ground-up construction showcasing contemporary design, sustainable practices, and integrated smart technology.',
            category: 'New Construction',
            imageUrl: projectGalleries.newHouse[0],
            gallery: projectGalleries.newHouse,
        },
        {
            id: 5,
            title: 'Downtown Condo Projects',
            description: 'Full-scale renovations of urban condos, maximizing space and implementing sophisticated, modern interiors.',
            category: 'Renovation',
            imageUrl: projectGalleries.condoProject[0],
            gallery: projectGalleries.condoProject  ,
        },
        {
            id: 6,
            title: 'James Montgomery Mansion Restoration',
            description: 'Dedicated restoration project for the historic James Montgomery Mansion, focusing on structural integrity and authentic finishes.',
            category: 'Restoration',
            imageUrl: projectGalleries.jamesMontgomery[0],
            gallery: projectGalleries.jamesMontgomery,
        },
        {
            id: 7,
            title: 'High-End Mansion Exteriors',
            description: 'Showcase of large-scale projects including luxury additions and exterior renovations on sprawling estates.',
            category: 'Interior/Exterior',
            imageUrl: projectGalleries.mansions[0],
            gallery: projectGalleries.mansions, 
        }
    ];

    const testimonials = [
        {
            text: "S&L Construction turned our outdated kitchen into the heart of our home. The team's attention to detail and ability to understand our vision was outstanding.",
            author: "Laura M."
        }
    ];

    return (
        <div className="page-wrapper">
            {/* 1. HEADER SECTION */}
            <HeaderContent 
                isMobileMenuOpen={isMobileMenuOpen} 
                setIsMobileMenuOpen={setIsMobileMenuOpen} 
            />

            {/* 2. MAIN CONTENT */}
            <main>
                <div className="projects-container" ref={sectionRef}>
                    <div className="projects-content">
                        <div className={`section-header ${isVisible ? 'animate-in' : ''}`}>
                            <span className="section-label">Our Portfolio</span>
                            <h2 className="section-title">Projects That Speak for Themselves</h2>
                            <p className="section-subtitle">
                                Our gallery showcases custom remodels and builds completed for clients who value quality, detail, and craftsmanship.
                            </p>
                        </div>

                        <div className="projects-grid">
                            {projects.map((project, index) => (
                                <div
                                    key={project.id}
                                    className={`project-card ${isVisible ? 'fade-in' : ''}`}
                                    style={{ animationDelay: `${index * 0.1}s`, cursor: 'pointer' }}
                                    onMouseEnter={() => setActiveProject(project.id)}
                                    onMouseLeave={() => setActiveProject(null)}
                                    // Click handler to open the modal
                                    onClick={() => openModal(project)} 
                                >
                                    {/* Uses .project-image-container and .project-image for the CSS fix */}
                                    <div className="project-image-container">
                                        <img 
                                            src={project.imageUrl} 
                                            alt={project.title} 
                                            className="project-image" 
                                        />
                                    </div>
                                    
                                    <div className="project-info">
                                        <span className="project-category">{project.category}</span>
                                        <h3 className="project-title">{project.title}</h3>
                                        <p className="project-location">{project.location}</p>
                                        <p className="project-description">{project.description}</p>
                                        <div className="project-arrow">
                                            <ArrowRight size={20} />
                                        </div>
                                    </div>
                                    <div className={`project-overlay ${activeProject === project.id ? 'active' : ''}`}></div>
                                </div>
                            ))}
                        </div>

                        <div className={`testimonials-section ${isVisible ? 'slide-in' : ''}`}>
                            <h2 className="testimonials-title">What Our Clients Say</h2>
                            <div className="testimonials-grid">
                                {testimonials.map((testimonial, index) => (
                                    <div key={index} className="testimonial-card">
                                        <div className="quote-icon">"</div>
                                        <p className="testimonial-text">{testimonial.text}</p>
                                        <div className="testimonial-author">
                                            <div className="author-name">{testimonial.author}</div>
                                            <div className="author-location">{testimonial.location}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            
            {/* Modal Component Rendered Here */}
            {modalProject && <ProjectModal project={modalProject} onClose={closeModal} />}

            {/* 3. FOOTER SECTION */}
            <FooterContent />
        </div>
    );
};

export default Projects;